import Model, { hasMany, attr } from '@ember-data/model';
import { sort, filter } from '@ember/object/computed';
import { get, computed, getProperties } from '@ember/object';
import moment from 'moment';

export default Model.extend({
  name: attr('string'),
  startDate: attr('date-only'),
  goalDate: attr('date-only'),
  filledOut: attr('boolean'),
  frequencyTimespan: attr('string'),
  frequencyNumber: attr('number'),
  staticInfo: attr(),
  sections: attr(),
  coachNotes: attr('string'),

  // only used when creating a new record from a template
  fromTemplateId: attr('string'),

  reports: hasMany('coaching/report', { async: false, inverse: null }),
  savedReports: filter('reports.@each.isNew', function (x) {
    return !get(x, 'isNew');
  }),
  sortReportsBy: Object.freeze(['startDate:asc']),
  sortedReports: sort('savedReports', 'sortReportsBy'),

  previousReport: function (report) {
    let sortedReports = this.sortedReports;
    let reportIndex = sortedReports.indexOf(report);
    if (reportIndex > 0) {
      return sortedReports[reportIndex - 1];
    } else {
      return null;
    }
  },

  sortReportsDescBy: Object.freeze(['startDate:desc']),
  sortedReportsDesc: sort('savedReports', 'sortReportsDescBy'),

  // number of reporting periods from startDate to goalDate
  reportingPeriodsToGoalDate: computed('startDate', 'goalDate', function () {
    let { startDate, goalDate, frequencyTimespan, frequencyNumber } =
      getProperties(
        this,
        'startDate',
        'goalDate',
        'frequencyTimespan',
        'frequencyNumber',
      );
    let reportingPeriods = 0;
    let goalDateString = moment(goalDate).format('YYYY-MM-DD');
    let date = moment(startDate);

    while (date.format('YYYY-MM-DD') < goalDateString) {
      reportingPeriods += 1;
      date.add(frequencyNumber, frequencyTimespan);
    }
    return reportingPeriods;
  }),

  // returns the section index and field index for each field
  // { fieldId: { sectionIndex, fieldIndex } }
  fieldsSectionAndIndex: computed('sections', function () {
    let fields = {};
    (this.sections || []).forEach((section, sectionIndex) => {
      get(section, 'fields').forEach((field, fieldIndex) => {
        fields[get(field, 'id')] = {
          sectionIndex,
          fieldIndex,
        };
      });
    });
    return fields;
  }),
});
